/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrSubscriptionModesEnum } from './irrSubscriptionModesEnum';
import { IrrConfigRWRTenantSpec } from './irrConfigRWRTenantSpec';
import { IrrConfigSettingsItem } from './irrConfigSettingsItem';


/**
 * IRR reconfigure tenant specification
 */
export interface IrrReConfigureTenantSpec { 
    /**
     * IRR FQDN
     */
    irr_fqdn: string;
    mode?: IrrSubscriptionModesEnum;
    rwrConfig?: IrrConfigRWRTenantSpec;
    send_sddc_quota?: boolean;
    settings?: Array<IrrConfigSettingsItem>;
    unlink_vmc_org?: boolean;
}
export namespace IrrReConfigureTenantSpec {
}


